import React, { useState } from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import data4 from "../../../../json/data4.json";
import images from "../../../../constant/images";
import videos from "../../../../constant/videos";
import { useTranslation } from "react-i18next";
import Header from "../../../../layouts/header";

export default function G_n() {
  const { i18n, t } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [video, setVideo] = useState("");

  const openModal = (video) => {
    setVideo(video);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setVideo("");
  };
  return (
    <div>
      {/* <div
        className=" flex flex-col "
        style={{
          backgroundImage: `url(${images.golfAndNetworking})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "60vh",
          backgroundRepeat: "no-repeat",
          position: "relative",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-20"></div>
        <div className=" relative">
          <Nav />
        </div>
        <div className="h-[50%] flex items-center justify-center">
          <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font ">
          {t("gtm_club_content.g_n_content.g_n")}
          </h1>
        </div>
        <svg
          className="absolute bottom-[-9%] left-0 "
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1440 320"
        >
          <path
            class="white"
            fill="#fff"
            fill-opacity="1"
            d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
          ></path>
        </svg>
      </div> */}
      <Header
        image={images.golfAndNetworking}
        title={t("gtm_club_content.g_n_content.g_n")}
      />

      <div className="flex flex-col items-center relative justify-center mt-12 mb-[6rem] ">
        <p
          className="px-4 sm:px-8 md:px-16 lg:px-[10rem] relative text-[#5a5a5a] text-base sm:text-lg md:text-xl karla-font leading-relaxed tracking-wide"
          style={{ wordSpacing: "0.2rem" }}
        >
          <span className="font-bold">
            {t("gtm_club_content.g_n_content.g_n")}{" "}
          </span>
          {t("gtm_club_content.g_n_content.content")}
        </p>

        <div>
          <h1 className="text-4xl text-center mb-[3rem] linn custom-font">
            {t("gtm_club_content.g_n_content.g_n")}
          </h1>
          <style>
            {`
          .linn {
            position: relative;
            margin-top: 5rem;
          }
          .linn::before {
            content: ' ';
            position: absolute;
            width: 6%;
            height: 1px;
            bottom: -13px;
            left: 47%;
            background-color: black;
          }

          .modal {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.8);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }

          .modal-video {
            max-width: 80%;
            max-height: 80%;
            background: white;
          }

          .modal-close {
            position: absolute;
            top: 20px;
            right: 20px;
            font-size: 2rem;
            color: white;
            cursor: pointer;
          }

          .video-container {
            position: relative;
            height: 500px; 
            width: 350px;
          }

          .video-background {
            position: absolute;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: -2;
          }

          .video-overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0, 0, 0, 0.6); 
            z-index: -1;
          }

          @media (max-width: 1024px) {
            .responsive-grid {
              grid-template-columns: 1fr;
              padding-left: 1rem;
              padding-right: 1rem;
            }
            
          .modal-video {
            width: 90%;
            max-height: 60%;
            position: fixed;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            background: white;
            z-index: 1001;
          }
            
            .video-container {
              height: 300px;
            }
            
            .modal-close {
              top: -20%;
              right: 5px;
              font-size: 1.5rem;
            }
        }

        `}
          </style>

          {isModalOpen && (
            <div className="modal">
              <div className="modal-video">
                <button className="modal-close" onClick={closeModal}>
                  X
                </button>
                <video width="100%" height="100%" controls autoPlay>
                  <source src={video} type="video/mp4" />
                </video>
              </div>
            </div>
          )}

          <div className="grid grid-cols-2 gap-6 responsive-grid">
            {data4?.map((item) => (
              <div className="border-[1px] border-black p-3" key={item.id}>
                <div className="video-container">
                  <video className="video-background" loop muted>
                    <source src={videos[item.video]} type="video/mp4" />
                  </video>

                  <div className="video-overlay"></div>

                  <div className="flex items-center justify-center flex-col h-full gap-3">
                    <h2 className="text-3xl text-white custom-font ">
                      {item.title}
                    </h2>
                    <p className="text-1xl text-white custom-font uppercase">
                      {item.date}
                    </p>
                    <img
                      src={images[item.icon]}
                      alt="icon"
                      className="lg:w-[6vw] lg:h-[11vh] cursor-pointer"
                      onClick={() => openModal(videos[item.video])}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
